import TeamzIcon from "@/assets/teamz.svg";
import { Lock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { buttonVariants } from "@/components/ui/button.styles";
import { cn } from "@/lib/utils";
import { routes } from "@/routes";

// Messagerie d'un club freemium : l'API ne lui délivre aucun token StreamChat, donc
// aucun client n'est instancié ici. On reproduit la surface de la messagerie avec une
// conversation factice de l'équipe Teamz — rien dans ce composant ne parle à StreamChat,
// et le club ne peut donc pas ouvrir de canal ni écrire à un joueur.
export function MessagesTeaser() {
  const { t } = useTranslation(["common"]);

  const sender = t("common:freemium.messages-teaser-sender");
  const message = t("common:freemium.messages-teaser-message");

  return (
    <div className="flex w-full overflow-hidden bg-white md:rounded-xl md:border md:border-neutral-400">
      {/* Liste des conversations : une seule entrée, déjà ouverte donc non cliquable. */}
      <aside className="hidden w-[30%] shrink-0 flex-col border-r border-neutral-400 md:flex">
        <div className="flex h-[68px] shrink-0 items-center px-4">
          <h1 className="text-lg font-semibold">{t("common:desktop-nav.messages")}</h1>
        </div>

        <div className="flex items-center gap-3 border-y border-neutral-200 bg-neutral-50 p-3">
          <TeamzAvatar />
          <div className="flex min-w-0 flex-col">
            <span className="truncate text-sm font-semibold">{sender}</span>
            <span className="truncate text-sm text-neutral-500">{message}</span>
          </div>
        </div>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex h-[68px] shrink-0 items-center gap-3 border-b border-neutral-400 px-4">
          <TeamzAvatar />
          <span className="font-semibold">{sender}</span>
        </div>

        <div className="flex flex-1 flex-col justify-end gap-3 overflow-y-auto p-4">
          <div className="flex items-end gap-2">
            <TeamzAvatar />
            <p className="max-w-md text-balance rounded-2xl rounded-bl-sm bg-neutral-100 px-4 py-3 text-sm">
              {message}
            </p>
          </div>

          <Link to={routes.plans} className={cn(buttonVariants({ variant: "default" }), "ml-11 w-fit")}>
            {t("common:freemium.see-plans")}
          </Link>
        </div>

        {/* Zone de saisie inerte : pas d'input, rien à soumettre. */}
        <div className="shrink-0 border-t border-neutral-400 p-3">
          <div className="flex items-center gap-2 rounded-xl bg-neutral-100 px-4 py-3 text-sm text-neutral-450">
            <Lock className="size-4 shrink-0" />
            <span>{t("common:freemium.messages-teaser-input")}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

function TeamzAvatar() {
  return (
    <div className="flex size-9 shrink-0 items-center justify-center rounded-full bg-neutral-100">
      <TeamzIcon className="h-4 w-7" />
    </div>
  );
}
